import { render, staticRenderFns } from "./OrgAlertTemplates.vue?vue&type=template&id=6693b548"
import script from "./OrgAlertTemplates.vue?vue&type=script&lang=js"
export * from "./OrgAlertTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports